























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import ClientFilter from '@/components/Filters/ClientFilter.vue';
import FlotaFilterAutocomplete from '@/components/Filters/FlotaFilterAutocomplete.vue';
import { ClientFilterI, FlotaFilterI } from '@/interfaces/Filters';
import { ConfigIntegracionInterface } from './activarIntegracionInterface';
import { ActivarIntegracionService } from './activarIntegracionService';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
    ClientFilter,
    FlotaFilterAutocomplete,
  },
})
export default class FilterActivarIntegracion extends Vue {
  response: any = {};
  activarIntegracionService = new ActivarIntegracionService();

  client: ClientFilterI = { id: '', nombre: '', rut: '' };
  flota: FlotaFilterI = { id: '', nombre: '' };
  $snotify: any;

  handleBuscarClick() {
    this.response = {
      client: this.client,
      flota: this.flota,
    };
    this.$emit('filter', this.response);
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: {} as any,
    });
  }

  @Watch('client')
  handleClients() {
    this.getConfig();
  }

  async getConfig() {
    const axiosResponse: AxiosResponse<
      MSResponse<ConfigIntegracionInterface>
    > = await this.activarIntegracionService.getIntegrationConfig();
    const msResponse: MSResponse<ConfigIntegracionInterface> =
      axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.$store.commit('setIntegrationConfig', msResponse.data);
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  clearFilters() {
    this.client = { id: '', nombre: '', rut: '' };
    this.flota = { id: '', nombre: '' };
    this.$emit('clear');
  }
}
